(() => {
  const focusable = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const body = document.body;

  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    const drawer = document.getElementById(button.getAttribute('aria-controls'));
    if (!drawer) return;
    button.addEventListener('click', () => {
      const isOpen = drawer.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(isOpen));
      body.classList.toggle('menu-open', isOpen);
      if (isOpen) drawer.querySelector(focusable)?.focus();
    });
  });

  document.querySelectorAll('[data-menu-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const drawer = button.closest('.mobile-menu');
      const toggle = document.querySelector('[data-menu-toggle]');
      drawer?.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
      body.classList.remove('menu-open');
      toggle?.focus();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelector('[data-menu-close]')?.click();
  });

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const step = Number(button.dataset.change || 0);
        const next = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((wrapper) => {
    const form = wrapper.querySelector('form');
    if (!form) return;
    const variantSelect = form.querySelector('[data-variant-select]');
    const variantData = form.querySelector('[data-variant-json]');
    if (!variantSelect || !variantData) return;
    const variants = JSON.parse(variantData.textContent);
    const optionInputs = form.querySelectorAll('[data-option-input]');
    const price = form.closest('.product-info')?.querySelector('[data-product-price]');
    const addButton = form.querySelector('[data-add-to-cart]');

    const updateVariant = () => {
      const selected = [...optionInputs].map((input) => input.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      variantSelect.value = variant.id;
      if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(variant.price / 100);
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.querySelector('span').textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  });

  document.querySelectorAll('[data-product-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('[data-product-gallery]');
      const featured = gallery?.querySelector('[data-product-gallery-main] img');
      if (!featured) return;
      featured.src = button.dataset.imageUrl;
      featured.srcset = button.dataset.imageSrcset || '';
      featured.alt = button.dataset.imageAlt || featured.alt;
      gallery.querySelectorAll('[data-product-gallery-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
      button.setAttribute('aria-current', 'true');
    });
  });

  document.querySelectorAll('[data-product-zoom]').forEach((button) => {
    button.addEventListener('click', () => {
      const zoomed = button.classList.toggle('is-zoomed');
      button.setAttribute('aria-pressed', String(zoomed));
      button.setAttribute('aria-label', zoomed ? 'Reset product image zoom' : 'Zoom product image');
    });
  });
})();
